import Vue from 'vue'
import VueRouter from 'vue-router'
import api from '../api'

Vue.use(VueRouter)
/* 解决访问重复路由报错问题：NavigationDuplicated: Avoided redundant navigation to current location: "/xxx" 开始 */
const originalPush = VueRouter.prototype.push
// 修改 原型对象中的push方法
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch((err) => err)
}

/* 解决访问重复路由报错问题：NavigationDuplicated: Avoided redundant navigation to current location: "/xxx" 结束 */

let routes = [
	{
		path: '/:channel(channel[1-9]\\d?)?',
		name: 'home',
		component: () => import('../pages/home/index.vue'),
	},
	{
		path: '/:channel(channel[1-9]\\d?)?/login',
		name: 'login',
		component: () => import('../pages/login/index.vue'),
	},
	{
		path: '/:channel(channel[1-9]\\d?)?/generate',
		name: 'generate',
		component: () => import('../pages/Generate.vue'),
		meta: {
			isAuth: true,
		},
	},
	{
		path: '/:channel(channel[1-9]\\d?)?/generate-result',
		name: 'result',
		component: () => import('../pages/Result/index.vue'),
		meta: {
			isAuth: true,
		},
	},
	{
		path: '/:channel(channel[1-9]\\d?)?/my-images',
		name: 'myImages',
		component: () => import('../pages/MyImages.vue'),
		meta: {
			isAuth: true,
		},
	},
	{
		path: '/:channel(channel[1-9]\\d?)?/trending-prompts/:id',
		name: 'trendingDetail',
		component: () => import('../pages/TrendingDetail/index.vue'),
	},
	{
		path: '/:channel(channel[1-9]\\d?)?/my-images/:id',
		name: 'MyPicDetail',
		component: () => import('../pages/MyPicDetail/index.vue'),
		meta: {
			isAuth: true,
		},
	},
	{
		path: '/:channel(channel[1-9]\\d?)?/privacy-policy',
		name: 'privacy',
		component: () => import('../pages/privacy.vue'),
	},
	{
		path: '/:channel(channel[1-9]\\d?)?/terms-of-services',
		name: 'terms-of-services',
		component: () => import('../pages/terms.vue'),
	},
	{
		path: '/:channel(channel[1-9]\\d?)?/disclaimer',
		name: 'disclaimer',
		component: () => import('../pages/disclaimer.vue'),
	},
	// 添加捕获所有未匹配路由的重定向
	{
		path: '*',
		redirect: '/',
	},
]
export default function createRouter(store) {
	const router = new VueRouter({
		mode: 'history',
		routes,
		scrollBehavior(to, from, savedPosition) {
			if (savedPosition) {
				return savedPosition
			} else {
				return { x: 0, y: 0 }
			}
		},
	})

	// 路由导航守卫
	router.beforeEach(async (to, from, next) => {
		// console.log('store.state.isAuth', store.state.isAuth);
		if (store.state.showCate) {
			store.state.showCate = false
		}

		// 直接进入结果页，跳转走
		if (to.name === 'result' && from.name !== 'generate') {
			next('/')
			return 
		}

		// 如果当前有任务，并且要跳去其他页面，要中断任务
		if (store.state.taskId > 0) {
			store.state.taskId = -1
		}
		
		if (to?.meta?.isAuth && !store.state.isAuth) {
			// 先尝试根据cookie获取用户信息
			const res = await api.getUserInfo()
			if (res?.user) {
				console.log('user info get', res)
				store.state.userInfo = res.user
				store.state.isAuth = true
				store.state.avatar = res.user.avatar
				next()
				return
			} else {
				next('/login')
				return
			}
		} else {
			next()
			return
		}
	})
	return router
}
